import type { ServiceLabel } from './types';

export const KSA_SERVICES: readonly ServiceLabel[] = [
  { key: 'ZATCA VAT Return',       label: 'ZATCA VAT Return',       jurisdiction: 'KSA' },
  { key: 'Corporate Tax',           label: 'Corporate Tax (ZATCA/MISA)', jurisdiction: 'KSA' },
  { key: 'WPS Payroll',             label: 'WPS Payroll',            jurisdiction: 'KSA' },
  { key: 'GOSI',                   label: 'GOSI',                    jurisdiction: 'KSA' },
  { key: 'Bookkeeping',             label: 'Bookkeeping',            jurisdiction: 'KSA' },
  { key: 'Company Registration',    label: 'Company Registration',   jurisdiction: 'KSA' },
  { key: 'Zakat Filing',            label: 'Zakat Filing',           jurisdiction: 'KSA' },
  { key: 'Corporate Tax Filing',    label: 'Corporate Tax Filing',   jurisdiction: 'KSA' },
  { key: 'VAT Registration',        label: 'VAT Registration',       jurisdiction: 'KSA' },
  { key: 'VAT Return Filing',       label: 'VAT Return Filing',      jurisdiction: 'KSA' },
  { key: 'Withholding Tax',         label: 'Withholding Tax Returns', jurisdiction: 'KSA' },
  { key: 'GOSI Compliance',         label: 'GOSI Compliance',        jurisdiction: 'KSA' },
  { key: 'CR Renewal',              label: 'Commercial Registration (CR) Renewal', jurisdiction: 'KSA' },
  { key: 'Municipality License',    label: 'Municipality License Renewal', jurisdiction: 'KSA' },
  { key: 'Other',                   label: 'Other',                  jurisdiction: 'KSA' },
] as const;